var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "presets-content" },
    [
      !_setup.groupedPresets || _setup.groupedPresets.length === 0
        ? _c(
            "div",
            { staticClass: "no-results" },
            [
              _c("font-awesome-icon", {
                staticClass: "no-results-icon",
                attrs: { icon: ["fa-solid", "fa-search"] },
              }),
              _vm._v(" "),
              _c("h4", [_vm._v("No effects found")]),
              _vm._v(" "),
              _c("p", [_vm._v("Try adjusting your search terms or filters")]),
            ],
            1
          )
        : [
            _c(
              "div",
              { staticClass: "grouped-presets" },
              _vm._l(_setup.groupedPresets, function (group) {
                return _c(
                  "div",
                  {
                    key: group.categoryInfo.category,
                    staticClass: "category-group",
                  },
                  [
                    _c("div", { staticClass: "category-header d-flex" }, [
                      group.categoryInfo.icon
                        ? _c(
                            "div",
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-2",
                                attrs: {
                                  icon: ["fa-solid", group.categoryInfo.icon],
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", [
                        _c("h3", { staticClass: "category-title" }, [
                          _vm._v(_vm._s(group.categoryInfo.label)),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "category-description" }, [
                          _vm._v(_vm._s(group.categoryInfo.description)),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "presets-grid" },
                      _vm._l(group.effects, function (preset, index) {
                        return _c(_setup.BodyPresetGridThumbnail, {
                          key: index,
                          attrs: {
                            preset: preset,
                            "is-selected":
                              _setup.selectedPreset?.id === preset.id,
                            disabled: _setup.isDisabledPreset(preset),
                          },
                          on: { select: _setup.handlePresetSelect },
                        })
                      }),
                      1
                    ),
                  ]
                )
              }),
              0
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }